<template>
  <svg id="icon-alert" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-183.5-12.5h554v512h-554z"/>
      <g transform="translate(3 3)">
        <path d="M5.912 1.184l-5.39 8.998A1.273 1.273 0 0 0 1.61 12.09h10.78a1.273 1.273 0 0 0 1.088-1.91l-5.39-8.997a1.273 1.273 0 0 0-2.176 0zM7 4.455V7" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <circle fill="currentColor" cx="7" cy="9.25" r=".75"/>
      </g>
    </g>
  </svg>
</template>
